/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateCustomerProfileRequest} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'
import {CreateCustomerProfileResponse} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'


export const createCustomerProfile = (request: CreateCustomerProfileRequest, options?: CashRequestOptions) => post<CreateCustomerProfileRequest, CreateCustomerProfileResponse>("/2.0/cash/create-customer-profile", request, {...options, rejectOnError: true })